/** Re-export shared promotion types (POS + online). */
export type {
  AppliedDiscount,
  CartEvaluationResult,
  EvaluatedCartLine,
  PricedCartLine,
  Promotion,
  PromotionApplyMode,
  PromotionChannel,
  PromotionConditions,
  PromotionKind,
  PromotionScope,
  PromotionTarget,
  PromotionTargetType,
  PromotionUpsertInput,
  PromotionWithTargets,
  ScheduleWindow,
  Weekday,
} from '@shared/promotions/promotionTypes';

export { DEFAULT_PROMOTION_CHANNELS } from '@shared/promotions/promotionTypes';
